export default "__VITE_ASSET__97b5173d__"